module.exports = __webpack_public_path__ + "img/blue-icon(1).822d63ce.png";